<template>
  <div id="goStorage">
    <table-title>出库确认信息</table-title>
    <Form ref="formValidates" style="height:100%" :model="formValidate" :label-width="120" inline :rules="ruleValidate">
      <Divider orientation="left">物流详情(只读)</Divider>
      <FormItem label="物流任务ID">
        <Input v-model="disableVal.logisticTaskId" disabled style="width:180px" />
      </FormItem>
      <FormItem label="物流子任务ID">
        <Input v-model="formValidate.logiSubTaskId" disabled style="width:180px" />
      </FormItem>
      <FormItem label="收货省市区">
        <Input v-model="disableVal.toAreaId" disabled style="width:180px" />
      </FormItem>
      <br />
      <FormItem label="收货仓库">
        <Input v-model="disableVal.toWarehouseId" disabled style="width:180px" />
      </FormItem>
      <FormItem label="发货仓库">
        <Input v-model="disableVal.fromWarehouseId" disabled style="width:180px" />
      </FormItem>
      <FormItem label="关联运单号">
        <Input v-model="disableVal.waybillId" disabled style="width:180px" />
      </FormItem>
      <br />
      <FormItem label="标的物小类">
        <Input v-model="disableVal.targetSubClassCode" disabled style="width:180px" />
      </FormItem>
      <FormItem label="标的物编码">
        <Input v-model="disableVal.targetCode" disabled style="width:180px" />
      </FormItem>
      <FormItem label="计划数量">
        <Input v-model="disableVal.planQty" disabled style="width:180px" />
      </FormItem>
      <br />
      <FormItem label="出库数量">
        <Input v-model="disableVal.shippingQty" disabled style="width:180px" />
      </FormItem>
      <FormItem label="出库时间">
        <Input v-model="disableVal.shippingDate" disabled style="width:180px" />
      </FormItem>
      <FormItem label="接收数量">
        <Input v-model="disableVal.receiveQty" disabled style="width:180px" />
      </FormItem>
      <br />
      <FormItem label="接收时间">
        <Input v-model="disableVal.receiveDate" disabled style="width:180px" />
      </FormItem>
      <FormItem label="归还数量">
        <Input v-model="disableVal.returnQty" disabled style="width:180px" />
      </FormItem>
      <FormItem label="归还时间">
        <Input v-model="disableVal.returnDate" disabled style="width:180px" />
      </FormItem> <br />
      <Divider orientation="left">出库确认</Divider>
      <FormItem label="出库数量" prop="outboundQty">
        <InputNumber :min="1" v-model="formValidate.outboundQty" placeholder="请输入出库数量" style="width: 180px" />
      </FormItem>
      <FormItem label="出库时间" prop="outboundTime">
        <DatePicker type="date" placeholder="请选择出库时间" :editable="false" @on-change="onOutboundTime" v-model="formValidate.outboundTime" style="width:180px"></DatePicker>
      </FormItem>
      <br />
      <!-- <FormItem label="交接单编号" prop="shippingNoteId">
                <Input v-model="formValidate.shippingNoteId" style="width:180px" />
            </FormItem>-->
      <FormItem label="交接单有效性" prop="shippingNoteValidity">
        <Select v-model="formValidate.shippingNoteValidity" style="width:180px">
          <Option v-for="item in shippingNoteVal" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <br />
      <FormItem label="备注">
        <Input type="textarea" :rows="2" v-model="formValidate.subTaskOutComment" style="width: 490px" />
      </FormItem>
      <br />
      <FormItem label="上传交接单">
        <upload ref="upFiles" :height="70" :width="489" title="上传交接单" @success="uploadSuccess" @delete="onDelete"></upload>
      </FormItem>
    </Form>

    <div style="text-align:center;padding-top:15px">
      <Button @click="reset">重置</Button>
      <Button type="primary" style="margin-left:10px" @click="submint">提交</Button>
      <Button type="warning" style="margin-left:10px" @click="goBlack">返回</Button>
    </div>
  </div>
</template>

<script>
import tableTitle from "@/components/tableTitle/tableTitle.vue";
import upload from "@/components/upload/upload";

export default {
  components: {
    tableTitle,
    upload,
  },
  props: ["data"],
  data() {
    return {
      formValidate: {
        logiSubTaskId: "",
        outboundQty: null,
        outboundTime: "",
        // shippingNoteId: '',//交接单
        shippingNoteValidity: "Y", //交接有效性
        subTaskOutComment: "",
        shippingNoteIdList: [],
      },
      disableVal: {},
      ruleValidate: {
        outboundQty: [{ required: true, message: "输入出库数量" }],
        outboundTime: [{ required: true, message: "请选择出库时间" }],
        // shippingNoteId: [{ required: true, message: '请输入交接单' }],
        shippingNoteValidity: [
          { required: true, message: "请选择交接单有效性", trigger: "change" },
        ],
      },
      shippingNoteVal: [
        { value: "Y", label: "有效" },
        { value: "N", label: "无效" },
      ],
    };
  },
  mounted() {
    this.formValidate.logiSubTaskId = this.data.logisticSubTaskId;

    this.disableVal.logisticTaskId = this.data.logisticTaskId;
    this.disableVal.toAreaId = this.data.toAreaId
      ? this.$options.filters["queryDict"](
          "region",
          "fullArea",
          this.data.toAreaId
        )
      : "";
    this.disableVal.toWarehouseId = this.data.toWarehouseId
      ? this.$options.filters["queryDict"](
          "bizObjects",
          "warehouse",
          this.data.toWarehouseId
        )
      : "";
    this.disableVal.fromWarehouseId = this.data.fromWarehouseId
      ? this.$options.filters["queryDict"](
          "bizObjects",
          "warehouse",
          this.data.fromWarehouseId
        )
      : "";
    this.disableVal.waybillId = this.data.waybillId;
      console.log(this.disableVal.targetSubClassCode)

    this.disableVal.targetSubClassCode = this.data.targetSubClassCode
      ? this.$options.filters["queryDict"](
          "target",
          "type",
          this.data.targetSubClassCode
        )
      : "";

    this.disableVal.targetCode = this.data.targetCode
      ? this.$options.filters["queryDict"](
          "target",
          "targetCodeUnion",
          this.data.targetCode
        )
      : "";
    this.disableVal.planQty = this.data.planQty;
    this.disableVal.shippingQty = this.data.shippingQty;
    this.disableVal.receiveQty = this.data.receiveQty;
    this.disableVal.returnQty = this.data.returnQty;
    this.disableVal.shippingDate = this.data.shippingDate
      ? new Date(this.data.shippingDate).Format("yyyy-MM-dd")
      : "";
    this.disableVal.receiveDate = this.data.receiveDate
      ? new Date(this.data.receiveDate).Format("yyyy-MM-dd")
      : "";
    this.disableVal.returnDate = this.data.returnDate
      ? new Date(this.data.returnDate).Format("yyyy-MM-dd")
      : "";
  },
  methods: {
    onOutboundTime(val) {
      this.formValidate.outboundTime = val;
    },
    // 上传附件回调
    uploadSuccess(params) {
      this.formValidate.shippingNoteIdList.push(params.body);
    },
    // 上传附件删除回调
    onDelete({ id }) {
      this.formValidate.shippingNoteIdList =
        this.formValidate.shippingNoteIdList.filter((item) => item != id);
    },
    reset() {
      this.$refs["formValidates"].resetFields();
      this.$refs.upFiles.$refs.uploadFile.clearFiles();
      this.formValidate.shippingNoteIdList = [];
      this.formValidate.subTaskOutComment = "";
    },
    submint() {
      this.$refs["formValidates"].validate((valid) => {
        let data = {
          url: "MID-OPERATE-LOGISTICS/messageService/logisticSubTaskService/logiSubTaskShipping",
          body: this.formValidate,
        };
        if (valid) {
          this.invoke(data).then((res) => {
            this.reset();
            this.goBlack();
            this.$Message.success("操作成功!");
          });
        }
      });
    },
    goBlack() {
      this.$emit("on-finish");
    },
  },
};
</script>
